import CraftVars from '../../services/craftVars';
let graphQLUrl = `${CraftVars.baseUrl}/graphql`;
export const CraftContent = {

  getEntries (settings = {}){

    const username = process.env.HTACCESS_USERNAME
    const password =  process.env.HTACCESS_PASSWORD

    const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')

    let queryVariables = {
      section : '',
      orderBy : 'postDate asc',
      ...settings
    };

    return new Promise((resolve) => {
      fetch(graphQLUrl,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Basic ${token}`
            },
            body: JSON.stringify({
              'query': `query ($section: [String], $limit: Int, $offset: Int) {
            entries (section: $section, limit: $limit, offset: $offset) {
              id
              title
            }
          }`,
              'variables': queryVariables
            })
          })
          .then(response => {
            return response.json();
          })
          .then(result => {
            resolve(result.data)
          })
          .catch(error => {
            console.log('Request failed', error)
          });
    });
  },

  getForm (settings = {}){

    const username = 'boilerplate'
    const password = 'boilerplateweb'

    const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')

    let queryVariables = {
      ...settings
    };

    return new Promise((resolve) => {
      fetch(graphQLUrl,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Basic ${token}`
            },
            body: JSON.stringify({
              'query': `query ($handle: String){
            freeform {
              form(handle: [$handle]) {
                csrfToken {
                  name
                  value
                }
                honeypot {
                  name
                  hash
                  timestamp
                }
                hash
              }
            }
          }`,
              'variables': queryVariables
            })
          })
          .then(response => {
            return response.json();
          })
          .then(result => {
            console.log(result.data)
            resolve(result.data)
          })
          .catch(error => {
            console.log('Request failed', error)
          });
    });
  }
}
